import React from "react";
import PrincipalLogo from "../../../assets/images/principal.png";
import { compose } from "redux";
import { withRouter } from "react-router";
import { text } from "../../../utils/styles/style";
import { Typography } from "@mui/material";
import { connect } from "react-redux";

const styles = {
  titleProgress: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#000000",
    fontFamily: "FS-Elliot-Bold, sans-serif"
  }
};

function OnProgress(props) {
  const { custData } = props;

  const ActiveLink = ({ content, link = false }) => {
    return (
      <a
        onClick={e => {
          if (custData.customerChannelCode === "Mini Program" && window.my) {
            e.preventDefault();
            window.my.navigateTo({
              url:
                "/pages/link/link?url=" +
                encodeURIComponent("https://www.principal.com.my/en/contact-us")
            });
          }
        }}
        href={link}
        className="active-link"
        target={link ? "_blank" : "_self"}
        rel="noopener noreferrer"
      >
        {content}
      </a>
    );
  };
  return (
    <div style={{ padding: "0 2rem", marginTop: 16 }}>
      <img
        src={PrincipalLogo}
        alt="Principal"
        style={{
          maxWidth: "40%",
          marginBottom: "16px",
          width: 124.7,
          height: 40
        }}
      />

      <Typography
        style={{ marginBottom: 20 }}
        sx={styles.titleProgress}
      >
        {"Cash In is in progress ....."}
      </Typography>
      <Typography
        style={{
          wordSpacing: "2px",
          fontSize: "16px",
          color: text.color.greyText,
          fontFamily: "FS-Elliot, sans-serif"
        }}
        component="p"
      >
        {`Your Cash In request is still pending, please check the Cash In status again after 15 to 30 minutes. For assitance, please contact our`}
        {
          <ActiveLink
            link="https://www.principal.com.my/en/contact-us"
            content=" customer support"
          >
            customer support
          </ActiveLink>
        }
      </Typography>
    </div>
  );
}

const withConnect = connect(
  state => ({
    ...state.FPXReducer
  }),
  {}
);

export default compose(
  withRouter,
  withConnect
)(OnProgress);
